var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHedgesAndContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.41 7.41L14.58 2.58C14.21 2.21 13.7 2 13.17 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.83C20 8.3 19.79 7.79 19.41 7.41ZM14 13C14.55 13 15 13.45 15 14V17C15 17.55 14.55 18 14 18H13C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18H10C9.45 18 9 17.55 9 17C9 16.45 9.45 16 10 16H13V15H10C9.45 15 9 14.55 9 14V11C9 10.45 9.45 10 10 10H11C11 9.45 11.45 9 12 9C12.55 9 13 9.45 13 10H14C14.55 10 15 10.45 15 11C15 11.55 14.55 12 14 12H11V13H14ZM14 8C13.45 8 13 7.55 13 7V3.5L17.5 8H14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHedgesAndContracts);
export default __webpack_public_path__ + "static/media/hedges-and-contracts.0097f6e024a143839cd7c105902a54c5.svg";
export { ForwardRef as ReactComponent };